import { useState } from "react";
import {
  browserLocalPersistence,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  setPersistence,
} from "firebase/auth";
import { auth, db } from "@/firebaseConfig.js";
import Button from "./Button";
import { PasswordInput } from "./PasswordInput";
import { FirebaseError } from "firebase/app";
import { errorMessages } from "@/assets/data/firebaseErrorMessage";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";

const Registration = () => {
  const [registerPassword, setRegisterPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [registerEmail, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const register = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await setPersistence(auth, browserLocalPersistence);

      if (registerPassword === confirmPassword) {
        const userCredential = await createUserWithEmailAndPassword(
            auth,
            registerEmail,
            confirmPassword
        );

        const user = userCredential.user;

        // Send Firebase's built-in "Email address verification" template.
        // Access to the platform is gated on user.emailVerified (see ActiveUserRoute).
        await sendEmailVerification(user);

        // Firestore: Создать документ пользователя
        const userDocRef = doc(db, "users", user.uid);
        const userData = {
          createdAt: serverTimestamp(),
          email: registerEmail,
          uid: user.uid,
          status: "moderation",        // по умолчанию в модерации
          telegram: "",                // пусто по умолчанию
          organization: "",            // пусто по умолчанию
          balance: 0,                  // баланс по умолчанию
          role: "user",
        };
        await setDoc(userDocRef, userData);

        // Realtime Database: Создать пользователя с начальными полями

        setLoading(false);
        setErrorMessage("");
      } else {
        setLoading(false);
        setErrorMessage("Пароли не совпадают. Попробуйте еще раз");
      }
    } catch (error) {
      setLoading(false);

      if (error instanceof FirebaseError) {
        setErrorMessage(errorMessages[error.code] || errorMessages.default);
      } else {
        setErrorMessage(errorMessages.default);
      }
    }
  };

  return (
    <>
      <h2 className="authentication-box__title">Sign Up</h2>

      <input
        className={`input  `}
        required
        id="email"
        name="email"
        type="email"
        placeholder="Email"
        onChange={(event) => setEmail(event.target.value)}
      />
      {errorMessage && (
        <p className="authentication-box__error"> {errorMessage} </p>
      )}
      <div className="authentication-box-passwords">
        <div className="authentication-box-passwords-item">
          <PasswordInput
            value={registerPassword}
            onChange={setRegisterPassword}
          />
        </div>
        <div className="authentication-box-passwords-item">
          <PasswordInput
            value={confirmPassword}
            onChange={setConfirmPassword}
            placeholder="Confirm Password"
          />
        </div>
      </div>

      <Button
        title={loading ? "Signing Up..." : "Sign Up"}
        onClick={register}
      />

      <p className="authentication-box__desc">
        The password must contain at least 6 characters.
      </p>
      <p className="authentication-box__text">
        Already have an account?{" "}
        <a className="authentication-box__link" href="/auth/sign-in">
          Sign In
        </a>
      </p>
    </>
  );
};

export default Registration;
